function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { makeGridSystemInterval } from './Grid.utils';
export var gridBreakpoints = ['9xl', '8xl', '7xl', '6xl', '5xl', '4xl', '3xl', '2xl', 'xl', 'lg', 'md', 'sm', 'xs'];
export var gridSystem = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, makeGridSystemInterval({
  columns: 12,
  margin: 71,
  gutter: 24,
  startsAt: '9xl',
  endsAt: '5xl',
  gridBreakpoints
})), makeGridSystemInterval({
  columns: 8,
  margin: 36,
  gutter: 36,
  startsAt: '4xl',
  endsAt: '2xl',
  gridBreakpoints
})), makeGridSystemInterval({
  columns: 4,
  margin: 20,
  gutter: 16,
  startsAt: 'xl',
  endsAt: 'sm',
  gridBreakpoints
})), {}, {
  [gridBreakpoints[gridBreakpoints.indexOf('xs')]]: {
    columns: 4,
    margin: 16,
    gutter: 16
  }
});
//# sourceMappingURL=Grid.constants.js.map